import React from "react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { HOW_TO_BUY_CARDS } from "./common/Helper";

const HowToBuySlider = () => {
  return (
    <div className="container lg:px-5 md:px-8 px-5 mx-auto">
      {/* Swiper container for the slider */}
      <Swiper
        modules={[Pagination]} // Use Pagination module for pagination control
        pagination={{
          dynamicBullets: false, // Do not use dynamic bullets for pagination
          clickable: true, // Make pagination bullets clickable
        }}
        slidesPerView={1} // Show one slide at a time
        centeredSlides={false} // Center the currently active slide
        spaceBetween={30} // Space between slides
        loop={true} // Enable looping of slides
        breakpoints={{
          0: {
            slidesPerView: 1,
          },
          765: {
            slidesPerView: 2,
          },
        }}
        className="swiper-container" // Custom class for styling Swiper container
      >
        {/* Render each card from HOW_TO_BUY_CARDS as a SwiperSlide */}
        {HOW_TO_BUY_CARDS.map((obj, index) => {
          return (
            <SwiperSlide
              className="px-3 lg:mt-20 md:mt-24 mt-20 flex h-auto justify-center"
              key={index}
            >
              {/* Slide content */}
              <div className="md:mt-48 sm:mt-32 mt-24 w-full mx-auto 2xl:shadow-xlPurpleShadow xl:shadow-lgPurpleShadow md:shadow-mdPurpleShadow shadow-smPurpleShadow hover:shadow-none hover:translate-y-5 hover:rotate-0 transition-all duration-300 ease-in-out border-4 border-dark-purple rounded-3xl rotate-3 bg-pink-bg h-full relative 2xl:py-14 py-7 2xl:px-10 px-5 ">
                {/* Image for the step */}
                <img
                  className="absolute sm:-top-24 -top-8 w-[142px] sm:w-[200px] h-[142px] sm:h-[200px] sm:right-4 right-8"
                  src={obj.image}
                  alt="Step-First-Icon"
                />
                <div className="text-white">
                  {/* Step number */}
                  <h4 className="sm:text-custom-3xl text-lg lg:py-12 sm:pt-12 sm:pb-8 pb-8 py-5">
                    step {index + 1}
                  </h4>
                  <div className="lg:pt-12 pt-3">
                    {/* Step heading and description */}
                    <h4 className="capitalize lg:text-custom-3xl text-2xl leading-7 max-w-[226px] sm:max-w-[unset]">
                      {obj.heading}
                    </h4>
                    <p className="sm:text-lg text-sm font-roboto lg:mt-10 sm:mt-6 mt-3">
                      {obj.description}
                    </p>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
};

export default HowToBuySlider;
